import { useCallback, useState, useEffect } from "react";
// import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import {
  TextField,
  InputAdornment,
  Icon,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./EditUserLimits.module.css";
import config from "../../../config/config";
import axios from "axios";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../../useDebouncedLog";
import { observer } from "mobx-react";

const EditUserLimits = observer(({ isVisible, onClose, openNoti, className = "" }) => {
  const [Txnlimt, setTxnlimt] = useState("");
  const [dailyLimit, setDailyLimit] = useState("");
  const [MonthlyLimit, setMonthlyLimit] = useState("");
  const [oldRoles, setOldRoles] = useState([]);
  const [adminEnabled, setAdminEnabled] = useState(false);
  const [ownerEnabled, setOWnerEnabled] = useState(false);
  const [userEnabled, setUserEnabled] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [AllTags, setAllTags] = useState([]);
  const [isViewAdmin, setIsViewAdmin] = useState(false);
  const [errormsg, setErrorMsg] = useState({
    isAnyFieldEmpty: false,
    isTxnLimitNegative: false,
    isDailyLimitNegative: false,
    isMonthlyLimitNegative: false,
    isTxnLimitExceeds: false,
    isDailyLimitExceedsMonthly: false,
    somethingWentWrong: false,
  });
  const [copied, setCopied] = useState(false);
  const [disabledLimits, setdisabledLimits] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  var logEditUserVisited;
  var logEditUserInvoked;
  try {
    logEditUserVisited = useDebouncedLog("admin_edit_user_visited", 500);
    logEditUserInvoked = useDebouncedLog("admin_edit_user_Invoked", 500);
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    logEditUserVisited();
    setAllTags(store.Tags.filter((tag) => tag !== ""));
    setTxnlimt(companyStore.txnLimit);
    setDailyLimit(companyStore.DailyLimit);
    setMonthlyLimit(companyStore.MonthlyLimit);
    if (
      companyStore.userType == "PineLabUser" &&
      !companyStore.UserHasWallet &&
      companyStore.userKycInfo
    ) {
      if (
        companyStore?.userKycInfo?.kyc_initiate_on &&
        companyStore?.userKycInfo?.initiate_kyc_bp_response?.status ==
        "kyc_initiated"
      ) {
        setUserEnabled(true);
        setdisabledLimits(true);
      } else {
        setdisabledLimits(false);
      }
    }
  }, [logEditUserVisited]);

  // console.log("ownerEnabled", ownerEnabled);
  // console.log("adminEnabled", adminEnabled);
  // console.log("userEnabled", userEnabled);

  useEffect(() => {
    // console.log("store.UserRoles", JSON.stringify(store.UserRoles));
    if (store.UserRoles.includes("OWNER")) {
    }
    if (store.UserRoles.includes("OWNER")) {
      setOWnerEnabled(true);
      setAdminEnabled(true);
      setIsViewAdmin(true);
      if (!oldRoles.includes("OWNER")) {
        oldRoles.push("OWNER");
      }
      // console.log("====>Owner");
    }
    if (store.UserRoles.includes("ADMIN")) {
      setAdminEnabled(true);
      if (!oldRoles.includes("ADMIN")) {
        oldRoles.push("ADMIN");
      }
      console.log("====>Admin");
    }
    if (store.UserRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
      setUserEnabled(true);
      if (!oldRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
        oldRoles.push("CUPI_COMPANY_EMPLOYEE");
      }
      // console.log("====>users");
    }
    if (store.UserRoles.includes("CUPI_VIEW_ADMIN")) {
      setIsViewAdmin(true);
      if (!oldRoles.includes("CUPI_VIEW_ADMIN")) {
        oldRoles.push("CUPI_VIEW_ADMIN");
      }
      // console.log("====>users");
    }
    if (store.UserRoles.length == 0) {
      setOWnerEnabled(false);
      setAdminEnabled(false);
      setUserEnabled(false);
      // console.log("diabled");
    }
    // console.log("oldRoles", oldRoles);
  }, []);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  const onFrameButtonClick = () => {
    try {
      logEditUserInvoked();
    } catch (err) {
      console.log("error", err);
    }
    setErrorMsg({
      isAnyFieldEmpty: false,
      isTxnLimitNegative: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
    });
    if (
      (Txnlimt == "" || dailyLimit == "" || MonthlyLimit == "") &&
      userEnabled
    ) {
      console.log("error");

      setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
      setErrorMessage("All Fields are required");
      return;
    }
    if (
      userEnabled &&
      (Number(dailyLimit) <= 0 ||
        Number(Txnlimt) <= 0 ||
        Number(MonthlyLimit) <= 0)
    ) {
      if (Number(dailyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
      }
      if (Number(Txnlimt) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
      }
      if (Number(MonthlyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
      }
      setErrorMessage("Limits Cannot be 0");
      return;
    }
    if (
      Number(Txnlimt) > Number(dailyLimit) ||
      Number(Txnlimt) > Number(MonthlyLimit)
    ) {
      setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
      setErrorMessage(
        "Transaction Limit should not be greater than dailyLimit or monthlyLimit",
      );
      return;
    }
    if (Number(dailyLimit) > Number(MonthlyLimit)) {
      setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
      setErrorMessage("Daily Limit should not be greater than monthlyLimit");
      return;
    }
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    try {
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
    } catch (er) {
      console.log("error", er);
    }

    let newRoles = [];
    if (ownerEnabled) {
      newRoles.push("OWNER");
    }
    if (adminEnabled) {
      newRoles.push("ADMIN");
      newRoles.push("CUPI_VIEW_ADMIN");
    }
    if (userEnabled) {
      if (companyStore.userType != "PineLabUser") {
        newRoles.push("CUPI_COMPANY_EMPLOYEE");
      } else if (companyStore.UserHasWallet) {
        newRoles.push("CUPI_COMPANY_EMPLOYEE");
      } else if (
        !companyStore.UserHasWallet &&
        !companyStore?.userKycInfo?.kyc_initiate_on
      ) {
        newRoles.push("CUPI_COMPANY_EMPLOYEE");
      }
    }
    if (isViewAdmin && !newRoles.includes("CUPI_VIEW_ADMIN")) {
      newRoles.push("CUPI_VIEW_ADMIN");
    }
    const haveRolesChanged = (oldRoles, newRoles) => {
      // Check if lengths differ
      if (oldRoles.length !== newRoles.length) return true;

      // Check if any role is different (order-independent)
      return (
        oldRoles.some((role) => !newRoles.includes(role)) ||
        newRoles.some((role) => !oldRoles.includes(role))
      );
    };

    const rolesChanged = haveRolesChanged(oldRoles, newRoles);
    // console.log("Roles have changed:", rolesChanged);
    if (rolesChanged) {
      setSuccessMessage("Role has been updated");
    } else if (
      Number(companyStore.txnLimit) != Number(Txnlimt) ||
      Number(companyStore.DailyLimit) != Number(dailyLimit) ||
      Number(companyStore.MonthlyLimit) != Number(MonthlyLimit)
    ) {
      setSuccessMessage(
        "The user transaction limits have been successfully updated",
      );
    } else {
      setSuccessMessage(
        "The user information have been successfully updated",
      );
    }

    if (
      rolesChanged &&
      (Number(companyStore.txnLimit) != Number(Txnlimt) ||
        Number(companyStore.DailyLimit) != Number(dailyLimit) ||
        Number(companyStore.MonthlyLimit) != Number(MonthlyLimit))
    ) {
      setSuccessMessage(
        "The user transaction limits and roles have been updated",
      );
    }
    // console.log(
    //   "  companyStore.userType == PineLabUser &&!companyStore.UserHasWallet",
    //   companyStore.userType == "PineLabUser" && !companyStore.UserHasWallet,
    // );

    if (
      companyStore.userType == "PineLabUser" &&
      !companyStore.UserHasWallet &&
      !companyStore?.userKycInfo?.kyc_initiate_on &&
      newRoles.includes("CUPI_COMPANY_EMPLOYEE")
    ) {
      let obj1;
      let phone = store.SelectedPhoneNo;
      if (phone.startsWith("+91")) {
        phone = phone.slice(3);
      }
      if (store.selectedEmail.trim()) {
        obj1 = JSON.stringify({
          user_name: store.name.trim(),
          user_email: store.selectedEmail.trim(),
          user_mobile_no: phone,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newRoles,
          tags: AllTags.join(", "),
        });
      } else {
        obj1 = JSON.stringify({
          user_name: store.name.trim(),
          user_mobile_no: phone,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newRoles,
          tags: AllTags.join(", "),
        });
      }
      // console.log("object", obj1);

      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/pine/create_cupi_compnay_user`,
        headers: {
          aws_cognito_id_token: parsedTokens?.IdToken,
          aws_cognito_access_token: parsedTokens?.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj1,
      };
      try {
        axios
          .request(payload)
          .then(async (res) => {
            let userExist;
            if (res.data.data) {
              userExist =
                res?.data?.data?.message == "User Already Exists :" ||
                res?.data?.data == "User KYC is pending";
            }
            if (userExist) {
              // console.log("UserExist");
              store.refresh ? store.setRefresh(false) : store.setRefresh(true);
              setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
              setErrorMessage("User Already Exists");
              return;
            }
            setIsUpdated(true);
            await new Promise((resolve) => setTimeout(resolve, 3000));
            setIsUpdated(false);
            // onClose();
            // openNoti();
          })
          .catch(async (err) => {
            setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
            setErrorMessage(
              "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
            );

            await new Promise((resolve) => setTimeout(resolve, 3000));
            setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
            setErrorMessage("");
          });
      } catch (err) {
        console.log(err);
      }
    } else {
      let obj;
      if (newRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
        obj = JSON.stringify({
          ledger_label: store.Company_Id,
          user_id: store.userId,
          create_at: store.create_at,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          roles: newRoles,
          tags: AllTags.join(", "),
        });
      } else {
        obj = JSON.stringify({
          ledger_label: store.Company_Id,
          user_id: store.userId,
          create_at: store.create_at,
          perTxnLimit: 0,
          dailyLimit: 0,
          monthlyLimit: 0,
          roles: newRoles,
          tags: AllTags.join(", "),
        });
      }
      if (companyStore.TagsEmpDetails) {
        let newtags = JSON.parse(JSON.stringify(companyStore.TagsEmpDetails))

        let objtest = {
          employee_code: newtags.Empcode,
          employee_department: newtags.Department,
          employee_location: newtags.location
        }
        obj = JSON.parse(obj)
        obj.employee_info = objtest
        obj = JSON.stringify(obj)
      }

      console.log("obj1", obj);

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/cupi_user_update_limit`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then(async (res) => {
          setIsUpdated(true);
          store.setTxnLimit(Number(Txnlimt));
          store.setDailyLimit(Number(dailyLimit));
          store.setmonthlyLimit(Number(MonthlyLimit));
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          await new Promise((resolve) => setTimeout(resolve, 3000));
          setIsUpdated(false);
        })
        .catch(async (err) => {
          console.log(err);

          setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
          setErrorMessage(
            "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
          );

          await new Promise((resolve) => setTimeout(resolve, 3000));
          setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
          setErrorMessage("");

          // setIsUpdated(true);
        });
    }
  };

  const copyToClipboard = async (linkToCopy) => {
    try {
      setCopied(true);
      await navigator.clipboard.writeText(linkToCopy);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
      setCopied(false);
    }
  };
  const removeTag = (data, index) => {
    setAllTags((prevTags) => {
      const newTags = [...prevTags];
      newTags.splice(index, 1);
      return newTags;
    });
  };
  if (!isVisible) return null;
  return (
    <div
      className={styles.frameParent}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          onClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        <div className={styles.frameWrapperContainer}>
          <div className={styles.frameWrapper}>
            <div className={styles.mobileMenuParentHeading}>
              Edit user details
            </div>

            <div className={styles.mobileMenuParent22}>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>NAME</div>
                <div className={styles.mobileMenuele2}>{store.name}</div>
              </div>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>USER PHONE NO</div>
                <div className={styles.mobileMenuele2}>
                  {store.SelectedPhoneNo}
                </div>
              </div>
              <div className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuele1}>USER EMAIL ID</div>
                <div className={styles.mobileMenuele2}>
                  {store.selectedEmail == "undefined"
                    ? "-"
                    : store.selectedEmail}
                </div>
              </div>
              <div className={styles.mobileMenuContainer1}>
                {(store.TagsEmpDetails?.Empcode || store.TagsEmpDetails?.location || store.TagsEmpDetails?.Department) ? (<div className={styles.mobileMenuContainer2}>
                  <div className={styles.mobileMenueleContainer}>
                    <div className={styles.mobileMenuele1}>USER EMPLOYEE DETAILS</div>
                    {!disabledLimits && companyStore?.userKycInfo?.initiate_kyc_bp_response?.status !=
                      "kyc_link_expired" && <div className={styles.mobileMenuelebtn}
                        onClick={() => {
                          console.log("store.TagsEmpDetails", store.TagsEmpDetails)
                          store.setShowEmpDetails(true);
                        }}>
                        <img
                          className={styles.arrowNarrowLeftIcon122}
                          alt=""
                          src="/edit-02.svg"
                        /></div>}</div>

                  <div className={styles.EmpinfoContentContainer}>
                    {store.TagsEmpDetails?.Empcode && (
                      <div className={styles.EmpinfoContent1}>
                        <img
                          className={styles.EmpinfoContenticon1}
                          alt=""
                          src="/user-square.svg"
                        />
                        {store.TagsEmpDetails?.Empcode.substring(0, 8)}
                      </div>
                    )}
                    {store.TagsEmpDetails?.location && (
                      <div className={styles.EmpinfoContent1}>
                        <img
                          className={styles.EmpinfoContenticon1}
                          alt=""
                          src="/location.svg"
                        />
                        {store.TagsEmpDetails.location.substring(0, 8)}
                      </div>
                    )}
                    {store.TagsEmpDetails?.Department && (
                      <div className={styles.EmpinfoContent1}>
                        <img
                          className={styles.EmpinfoContenticon1}
                          alt=""
                          src="/building-06.svg"
                        />
                        {store.TagsEmpDetails?.Department.substring(0, 8)}
                      </div>
                    )}
                  </div>
                </div>) : (
                  <div className={styles.mobileMenuContainer111}>
                    {!disabledLimits && companyStore?.userKycInfo?.initiate_kyc_bp_response?.status !=
                      "kyc_link_expired" ? <button
                        className={styles.invertloadsButtons}
                        onClick={() => {
                          store.setShowEmpDetails(true);
                        }}
                      >
                      <img
                        className={styles.arrowNarrowLeftIcon1}
                        alt=""
                        src="/pluscircleBlue.svg"
                      />
                      <b>Add Employee Details</b>
                    </button> : <button
                      className={styles.invertloadsButtons}

                    >
                      <img
                        className={styles.arrowNarrowLeftIcon1}
                        alt=""
                        src="/pluscircleBlue.svg"
                      />
                      <b>Add Employee Details</b>
                    </button>}
                  </div>
                )}
                <div className={styles.mobileMenuele1}>TAGS</div>
                <div className={styles.setTransactionTagLimit}>
                  {AllTags.map((data, index) => {
                    let ShowTag = data;
                    if (data.includes(":")) {
                      const [key, value] = data.split(":");
                      ShowTag = value;
                    }
                    return (
                      <>
                        {data !== "" && (
                          <div className={styles.setTransactionOneTag}>
                            {ShowTag}
                            {/* <button
                                className={styles.setTransactionButton}
                                onClick={() => {
                                  removeTag(data, index);
                                }}
                              >
                                <img
                                  className={styles.arrowNarrowLeftIcon1}
                                  alt=""
                                  src="/Close.svg"
                                />
                              </button> */}
                          </div>
                        )}
                      </>
                    );
                  })}
                  {AllTags.length == 0 && (
                    <div className={styles.mobileMenuele2}>
                      No tags available.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.setTransactionLimitWrapper}>
            <div className={styles.addUserDetails}>Set transaction limit</div>
          </div>
          <div className={styles.frameWrapper1}>
            <div className={styles.mobileMenuParent}>
              <div className={styles.mobileMenu}>
                <TextField
                  color="primary"
                  value={Txnlimt}
                  type="number"
                  required
                  disabled={
                    (!store.isUserOwner && adminEnabled) ||
                    (!store.isUserOwner && isViewAdmin) ||
                    disabledLimits
                  }
                  label="Per transaction limit"
                  onChange={(e) => {
                    setIsUpdated(false);
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isTxnLimitNegative: false,
                      isTxnLimitExceeds: false,
                    }));

                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setTxnlimt(value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      appearance: "none",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    },
                  }}
                />
                {(errormsg.isTxnLimitNegative ||
                  errormsg.isTxnLimitExceeds) && (
                    <div className={styles.errorDiv}>
                      <div className={styles.error}>{ErrorMessage}</div>
                    </div>
                  )}
                {errormsg.isAnyFieldEmpty && Txnlimt == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>

              <div className={styles.mobileMenu}>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={dailyLimit}
                  type="number"
                  required
                  disabled={
                    (!store.isUserOwner && adminEnabled) ||
                    (!store.isUserOwner && isViewAdmin) ||
                    disabledLimits
                  }
                  label="Daily limit"
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setDailyLimit(value);
                    setIsUpdated(false);
                  }}
                  onWheel={(e) => e.target.blur()}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    },
                  }}
                />

                {(errormsg.isDailyLimitNegative ||
                  errormsg.isDailyLimitExceedsMonthly) && (
                    <div className={styles.errorDiv}>
                      <div className={styles.error}>{ErrorMessage}</div>
                    </div>
                  )}
                {errormsg.isAnyFieldEmpty && dailyLimit == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>

              <div className={styles.mobileMenu}>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={MonthlyLimit}
                  type="number"
                  required
                  disabled={
                    (!store.isUserOwner && adminEnabled) ||
                    (!store.isUserOwner && isViewAdmin) ||
                    disabledLimits
                  }
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setIsUpdated(false);
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setMonthlyLimit(value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  label="Monthly limit"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      maxHeight: "3.1rem",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    },
                  }}
                />
                {errormsg.isMonthlyLimitNegative && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
                {errormsg.isAnyFieldEmpty && MonthlyLimit == "" && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.RolesContainerMain}>
              {((!adminEnabled && !isViewAdmin) || store.isUserOwner) && (
                <div className={styles.AdminHeader}>Set Role*</div>
              )}
              <div className={styles.RolesContainer}>
                {(!adminEnabled || store.isUserOwner) && store.isUserOwner && (
                  <>
                    {store.userId.toUpperCase() == "NA" ? (
                      <div className={styles.mobileMenuContainer12Dis}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={adminEnabled}
                                onChange={(event) => { }}
                              />
                            }
                            label="Admin"
                          />
                        </FormGroup>
                      </div>
                    ) : (
                      <div
                        className={
                          ownerEnabled
                            ? styles.mobileMenuContainer12Dis
                            : styles.mobileMenuContainer12
                        }
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={adminEnabled}
                                onChange={(event) => {
                                  if (!ownerEnabled) {
                                    setAdminEnabled(event.target.checked);
                                    setIsViewAdmin(event.target.checked); //VIEW ADMIN ROLE
                                  }
                                }}
                              />
                            }
                            label="Admin"
                          />
                        </FormGroup>
                      </div>
                    )}
                  </>
                )}
                {((!adminEnabled && !isViewAdmin) || store.isUserOwner) &&
                  (disabledLimits ? (
                    <div className={styles.mobileMenuContainer12Dis}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={true}
                            // onChange={(event) =>
                            //   setUserEnabled(event.target.checked)
                            // }
                            />
                          }
                          label="App User"
                        />
                      </FormGroup>
                    </div>
                  ) : (
                    <div className={styles.mobileMenuContainer12}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={userEnabled}
                              onChange={(event) =>
                                setUserEnabled(event.target.checked)
                              }
                            />
                          }
                          label="App User"
                        />
                      </FormGroup>
                    </div>
                  ))}
              </div>
              {console.log(
                "store.userId.toUpperCase()",
                store.userId.toUpperCase(),
              )}
              {store.isUserOwner && (
                <>
                  {store.userId.toUpperCase() == "NA" ? (
                    <div className={styles.ViewToggleDis}>
                      <div className={styles.ViewToggleHead1}>
                        Dashboard viewer
                        <Checkbox
                          checked={isViewAdmin || adminEnabled}
                          onChange={(event) => { }}
                        />
                      </div>
                      <div className={styles.ViewToggleBody1}>
                        <span className={styles.ViewToggleNote}>Note: </span>
                        Viewers only see CUPI Web Dashboard usage
                      </div>
                    </div>
                  ) : (
                    <div
                      className={
                        adminEnabled || (store.isUserOwner && ownerEnabled)
                          ? styles.ViewToggleDis
                          : styles.ViewToggle
                      }
                    >
                      <div className={styles.ViewToggleHead1}>
                        Dashboard viewer
                        <Checkbox
                          checked={isViewAdmin || adminEnabled}
                          onChange={(event) => {
                            if (
                              !ownerEnabled ||
                              (store.isUserAdmin &&
                                !adminEnabled &&
                                !isViewAdmin)
                            ) {
                              setIsViewAdmin(event.target.checked);
                            }
                          }}
                        />
                      </div>
                      <div className={styles.ViewToggleBody1}>
                        <span className={styles.ViewToggleNote}>Note: </span>
                        Viewers only see CUPI Web Dashboard usage
                      </div>
                    </div>
                  )}
                </>
              )}
              {store.isUserOwner &&
                companyStore.userType == "PineLabUser" &&
                userEnabled &&
                !companyStore.UserHasWallet && (
                  <div className={styles.ViewNote}>
                    <div className={styles.ViewNoteText}>
                      {companyStore?.userKycInfo?.kyc_initiate_on
                        ? "Can not edit until User KYC is completed. Please check User section for KYC Status."
                        : "To add as an App user, KYC needs to be completed. The KYC link will be sent to the User."}
                    </div>
                  </div>
                )}
            </div>
          </div>
          {isUpdated && successMessage && (
            <div className={styles.Completed}>
              <img
                className={styles.Completedicon}
                alt=""
                src="/check-circle.svg"
              />
              <div className={styles.CompletedText}>{successMessage}</div>
            </div>
          )}
          {errormsg.somethingWentWrong && (
            <div className={styles.Failed}>
              {/* <img
                className={styles.Completedicon}
                alt=""
                src="/check-circle.svg"
              /> */}
              <div className={styles.FailedText}>{ErrorMessage}</div>
            </div>
          )}

          {companyStore.userType == "PineLabUser" &&
            store?.userKycInfo?.initiate_kyc_bp_response?.kycLink?.webLink &&
            store.userKycInfo?.initiate_kyc_bp_response?.status ==
            "kyc_initiated" &&
            !store?.UserHasWallet && (
              <div className={styles.CopyLinkContainer}>
                <div className={styles.CopyLinkHeader}>
                  <span className={styles.CopyLinkHeaderBold}>Note:</span>Please
                  Copy and share this link with the user to restart KYC.
                </div>
                <div className={styles.CopyLinkbody}>
                  <img className={styles.CopyLinkImg} alt="" src="/link.svg" />

                  <div className={styles.CopyLinklink}>
                    {store?.userKycInfo?.initiate_kyc_bp_response?.kycLink?.webLink?.substring(
                      0,
                      23,
                    ) + " "}
                    ...
                  </div>

                  {!copied ? (
                    <button
                      className={styles.CopyLinkBtn}
                      onClick={() => {
                        copyToClipboard(
                          store?.userKycInfo?.initiate_kyc_bp_response?.kycLink
                            ?.webLink,
                        );
                      }}
                    >
                      <img
                        className={styles.CopyLinkBtnimg}
                        alt=""
                        src="/copyIcon.svg"
                      />
                      Copy
                    </button>
                  ) : (
                    <div className={styles.CopyLinkBtn2}>Copied</div>
                  )}
                </div>
              </div>
            )}
          {((!adminEnabled && !isViewAdmin) || store.isUserOwner) &&
            !store.isUserGlobalViewAdmin &&
            !store.isUserViewAdmin && (
              <div
                className={styles.loadsButtons}
                onClick={() => {
                  onFrameButtonClick();
                }}
              >
                Submit
              </div>
            )}
          {companyStore.userType == "PineLabUser" && (
            <div className={styles.finalCupiLogo}>
              <img
                className={styles.escrowLogo}
                alt=""
                src="/PineLabsLogo.svg"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

EditUserLimits.propTypes = {
  className: PropTypes.string,
};

export default EditUserLimits;
